import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import OfflineExporting from 'highcharts/modules/offline-exporting.src';
import Draggable from 'react-draggable';
import { Button } from 'react-bootstrap';
import withChartExport from '../../../components/ChartExporting';

import highchartFactory from '../../../util/highcharts';
const highchartUtils = highchartFactory(Highcharts);

import expandIcon from '../../../assets/img/zoom-icon-off.svg';
import collapseIcon from '../../../assets/img/zoom-icon-on.svg';

import { saveConfig, updateLineChart } from '../../../components/Filter/FilterActions';
import dateUtils from '../../../util/dates';

const config = {
  chart: {
    type: 'spline',
    backgroundColor: '#fff'
  },
  exporting: {
    enabled: false
  },
  credits: {
    enabled: false
  },
  title: {
    text: ''
  },
  legend: {
    enabled: false
  },
  colors: ['#0086b3'],
  tooltip: {
    useHTML: true,
    formatter: function() {
      return `${this.y}%`;
    }
  },
  xAxis: {
    type: 'datetime',
    gridLineWidth: 0,
    ordinal: false,
    showLastTickLabel: true,
    title: {
      text: null
    },
    plotLines: [
      {
        value: 0
      }
    ]
  },
  yAxis: {
    gridLineWidth: 0,
    labels: {
      enabled: false
    },
    title: {
      text: null
    },
    showFirstLabel: false
  },
  plotOptions: {
    spline: {
      marker: {
        enabledThreshold: 2,
        lineWidth: 1,
        radius: 5
      },
      states: {
        hover: {
          lineWidth: 2,
          halo: {
            opacity: 0
          },
          marker: {
            enabled: true
          }
        }
      }
    }
  },
  series: [
    {
      marker: {
        symbol: 'circle'
      },
      name: '',
      data: []
    }
  ]
};

const DEFAULT_POS = { x: 95, y: 85 };

export class OnTimeDeliveryWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      current: '0.00',
      isFullSreen: false,
      width: undefined,
      height: undefined,
      pos: DEFAULT_POS
    };
  }

  componentDidMount() {
    highchartUtils.setDefaults();
    Exporting(Highcharts);
    OfflineExporting(Highcharts);

    config.exporting = { ...config.exporting, ...this.props.chartExporting };

    this.chart = new Highcharts['Chart'](`on_time_delivery_chart_container`, config);

    if (this.props.data && this.props.data.length) {
      this.updateDateFormat();
      this.calculateChartData();
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.data, this.props.data)) {
      this.calculateChartData();
      this.updateDateFormat();
    }

    if (prevProps.dateFormat != this.props.dateFormat) {
      this.updateDateFormat();
    }
  }

  calculateChartData() {
    if (!this.props.data.length) {
      return false;
    }

    const last = _.last(this.props.data);
    if (last) {
      this.setState({
        current: last.y
      });
    }

    this.chart.update({
      xAxis: {
        plotLines: [
          {
            color: '#F5F5F5',
            width: 1,
            value: this.props.data[0].x,
            label: {
              text: ''
            }
          }
        ]
      },
      series: [
        {
          data: this.props.data
        }
      ]
    });
  }

  handleClose = () => {
    this.props.close();
    this.props.saveConfig();
  };

  handleResize = () => {
    if (this.state.isFullSreen) {
      this.setState(
        {
          width: undefined,
          height: undefined,
          left: undefined,
          isFullSreen: false,
          pos: DEFAULT_POS
        },
        () => this.updateFontSize()
      );
    } else {
      this.setState(
        {
          width: '100%',
          height: '100%',
          left: -10,
          isFullSreen: true,
          pos: { x: 0, y: 0 }
        },
        () => this.updateFontSize()
      );
    }
  };

  updateFontSize = () => {
    this.chart.update({
      exporting: {
        enabled: this.state.isFullSreen,
        chartOptions: {
          title: {
            text: 'On-Time Delivery',
            style: {
              fontSize: '16px',
              fontWeight: 'bold'
            }
          }
        }
      },
      yAxis: {
        gridLineWidth: +this.state.isFullSreen,
        labels: {
          enabled: this.state.isFullSreen
        }
      }
    });

    this.chart.reflow();
  };

  handleDrag = (e, data) => {
    this.setState({ pos: { x: data.x, y: data.y } });
  };

  updateDateFormat() {
    this.chart.update({
      xAxis: {
        dateTimeLabelFormats: dateUtils.createHighchartFormats(this.props.dateFormat)
      }
    });
  }

  render() {
    return (
      <Draggable axis="both" position={this.state.pos} onStop={this.handleDrag} bounds="parent">
        <div
          className={`box_white_shadow chart_averages_box ${this.state.isFullSreen ? 'fullscreen' : ''}`}
          style={{
            width: this.state.width,
            height: this.state.height,
            left: this.state.left,
            position: this.state.isFullSreen ? 'absolute' : ''
          }}
        >
          <div className='box_white_title mb-4'>
            <h3>On-Time Delivery</h3>
            <div className='right-actions'>
              <Button variant='secondary' size='sm'
                className={`btn-action ${this.state.isFullSreen ? 'fullscreen' : ''}`}
                onClick={this.handleResize}
              >
                <img src={this.state.isFullSreen ? expandIcon : collapseIcon} alt="toggleFullSreen" />
              </Button>
              <Button className="btn-action" onClick={this.handleClose}>
                &times;
              </Button>
            </div>
          </div>
          
          <p>{this.state.current}%</p>

          <div id="on_time_delivery_chart_container" />
        </div>
      </Draggable>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    close: () => dispatch(updateLineChart(false, 'ddp')),
    saveConfig: () => dispatch(saveConfig())
  };
};

const mapStateToProps = state => {
  return {
    dateFormat: state.filters.dateFormat,
    dashboard: state.dashboards.selected
  };
};

export default withChartExport(connect(mapStateToProps, mapDispatchToProps)(OnTimeDeliveryWidget));
